

import React, { useState, useRef, useEffect } from "react";
import { Button} from "antd";
import "antd/dist/antd.css";



type GenericButtonProps={
  onBtnClick: React.MouseEventHandler<HTMLElement>
  
}


function GenericButton({onBtnClick}:GenericButtonProps) {  
  
  return (

    <div style={{marginTop:20}}>
          <Button type="primary" htmlType="submit" onClick={onBtnClick}>
          Continue
          </Button>
   </div>


  );
}

export default GenericButton;
